// extracted by mini-css-extract-plugin
module.exports = {"root":"_3_y9M","link":"_3sCIY"};